import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AdalService } from 'adal-angular4';

@Injectable()
export class AdalRoleGuard implements CanActivate, CanActivateChild {

    constructor(
        private adalService: AdalService
    ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    if (this.adalService.userInfo.authenticated) {
        return this.adalService.userInfo.profile.roles.some(userRole => 
            route.data.roles.some(routeRole => 
                routeRole === userRole));
    }

    return false;
  }

    public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(childRoute, state);
    }
}